import { InjectionToken } from '@angular/core';

export const SIGNAL_R_API_URL = new InjectionToken<string>('SIGNAL_R_API_URL');
